/**
 * @type {ContainerLargeType}
 */
export const ContainerLargeType = {
  A: 'A',
  B1: 'B1',
  B2: 'B2',
  C: 'C',
};

/**
 * @type {ContainerLargeBgColorType}
 */
export const ContainerLargeBgColor = {
  Brand: 'Brand',
  Grey: 'Grey',
};
